import SimpleDate from 'app/common/classes/simple-date'

export const encashmentsDateFormat = 'DD.MM.YYYY'

export enum EncashmentsStatusType {
  CashAccepted = 'cashAccepted',
  CashRefused = 'cashRefused',
  WaitingForCash = 'waitingForCash',
  CashNotDeposited = 'cashNotDeposited',
}

export const isEncashmentsStatusType = (value: unknown): value is EncashmentsStatusType => {
  return Object.values(EncashmentsStatusType).includes(value as EncashmentsStatusType);
};

export const encashmentsStatusTitle = {
  cashAccepted: 'Наличные приняты',
  cashRefused: 'Отказано',
  waitingForCash: 'Ожидает принятия наличных',
  cashNotDeposited: 'Наличные не сданы'
}

export type StatusesType = {
  [k in EncashmentsStatusType]: string
}

export type TotalEncashmentsSummaryType = {
  balanceAtTheBeginning: string
  revenue: string
  collected: string
  balanceAtTheEnd: string
  statuses: StatusesType
}

export type EncashmentsSummaryType = {
  schoolId: string
  schoolTitle: string
  buildingTitle: string
  salePointId: string,
  salePointTitle: string
  status: EncashmentsStatusType | null
  comment: string | null
  balanceAtTheBeginning: string
  revenue: string
  collected: string
  balanceAtTheEnd: string
  encashmentsCount: number
}

type RowEncashmentId = string

export type EncashmentsDetailsType = {
  id: RowEncashmentId
  time: SimpleDate
  balanceAtTheBeginning: string
  revenue: string
  collected: string
  balanceAtTheEnd: string
}

export type EncashmentsRowItemType = {
  encashmentsSummary: EncashmentsSummaryType
  encashmentsDetails: Array<EncashmentsDetailsType>
}

export type ReportEncashmentsData = {
  date: SimpleDate
  rows: Array<EncashmentsRowItemType>
  totalSummary: TotalEncashmentsSummaryType
}

